import { bugReportLoaders } from './bugReports';
import { userSuggestionLoaders } from './userSuggestion';

export const feedbackLoaders = {
  ...userSuggestionLoaders,
  ...bugReportLoaders,
};
